import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/lenis";

const LOGO_URL = "/images/logo.png";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-white">
    <div className="px-6 md:px-12 lg:px-24 pt-24 md:pt-32 pb-12">
      <button
        data-testid="footer-lets-talk"
        onClick={() => scrollToSection("#contact")}
        className="font-display font-semibold tracking-tighter text-[13vw] md:text-[8vw] leading-[0.9] text-white hover:text-chrome transition-colors duration-500 text-left"
      >
        LET'S TALK.
      </button>
      <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
        <div>
          <div className="bg-white inline-block p-3">
            <img src={LOGO_URL} alt="Obrigado PH Holdings" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-white/60 mt-5 max-w-xs leading-relaxed">
            Sourcing, beneficiation and distribution of chrome concentrate — 40–42% and higher grades. Mining Prodigies.
          </p>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 mb-5">Contact</div>
          <a data-testid="footer-phone" href="tel:+27823706110" className="block text-white/80 hover:text-white transition-colors duration-300">082 370 6110</a>
          <a data-testid="footer-email" href="mailto:Obrigadoptyltd@gmail.com" className="block text-white/80 hover:text-white transition-colors duration-300 mt-2 break-all">Obrigadoptyltd@gmail.com</a>
          <p className="text-white/80 mt-2">South Africa — Global Delivery</p>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 mb-5">Navigate</div>
          {[
            { label: "Manifesto", target: "#manifesto", testid: "footer-nav-manifesto" },
            { label: "Product", target: "#product", testid: "footer-nav-product" },
            { label: "Capabilities", target: "#capabilities", testid: "footer-nav-capabilities" },
            { label: "On Site", target: "#on-site", testid: "footer-nav-onsite" },
            { label: "Contact", target: "#contact", testid: "footer-nav-contact" },
          ].map((l) => (
            <button key={l.label} data-testid={l.testid} onClick={() => scrollToSection(l.target)} className="block text-white/80 hover:text-white transition-colors duration-300 mt-2 first:mt-0">
              {l.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          © {new Date().getFullYear()} Obrigado PH Holdings. All rights reserved.
        </p>
        <Link data-testid="footer-admin-link" to="/admin" className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 hover:text-white transition-colors duration-300">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
